<ax-image-preview-button [source]="source" [name]="name"></ax-image-preview-button>
<p class="name">{{ name }}</p>
